import { useMemo } from 'react';
//@ts-expect-error untyped dependency
import normalizeReport from 'reporting-reports/normalizeReport';
import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { isFailed, isLoading } from 'reporting-data/asyncData/AsyncData';
import { AsyncStatus } from 'reporting-data/asyncData/AsyncStatus';
const fetcher = ({
  report
}) => {
  return normalizeReport(report);
};
export const useNormalizedReport = ({
  report
}) => {
  const requestArgs = useMemo(() => {
    return {
      report
    };
  }, [report]);
  const asyncData = useAsyncFetcher({
    fetcher,
    requestArgs
  });
  const result = useMemo(() => {
    if (isLoading(asyncData)) {
      return asyncData;
    }
    if (isFailed(asyncData)) {
      return Object.assign({}, asyncData, {
        status: AsyncStatus.SUCCEEDED,
        data: report
      });
    }
    return asyncData;
  }, [asyncData, report]);
  return result;
};